// @flow
import env from '../../environment';
import {getCreator} from '../../http';

export const endpoints = Object.freeze({
  GET_STORE: `${env.baseApiUrl}/gusher-gateway/admin/store/domain/:domain`, //Previous : /usher/store
  GET_STORE_PREVIOUS_TIER: `${env.baseApiUrl}/usher/store/store-tier/previous`,

  GET_STORE_METADATA: `${env.baseApiUrl}/gusher-gateway/store/metadata/:storeId`,
});

export const getStoreApi = getCreator(endpoints.GET_STORE);
export const getStorePreviousTierApi = getCreator(
  endpoints.GET_STORE_PREVIOUS_TIER
);

export const getStoreMetadataApi = getCreator(endpoints.GET_STORE_METADATA);
